import { useState, useEffect, useCallback } from "react";
import {
  collection, onSnapshot, addDoc, deleteDoc,
  doc, serverTimestamp, query, orderBy,
} from "firebase/firestore";
import { db } from "../firebase";

const COL = "activities";

export function useActivities() {
  const [activitiesMap, setActivitiesMap] = useState({});

  // Migrate existing localStorage activities on first load
  useEffect(() => {
    const migrated = localStorage.getItem("revoya_activities_migrated");
    if (!migrated) {
      try {
        const saved = JSON.parse(localStorage.getItem("revoya_activities"));
        if (saved) {
          Object.entries(saved).forEach(([prospectId, acts]) => {
            acts.forEach((a) => {
              addDoc(collection(db, COL), {
                prospectId,
                type: a.type,
                note: a.note || "",
                user: a.user || "Sales Team",
                date: a.date || new Date().toISOString(),
                createdAt: serverTimestamp(),
              });
            });
          });
          localStorage.setItem("revoya_activities_migrated", "true");
        }
      } catch {}
    }
  }, []);

  // Real-time listener — build a map { [prospectId]: [activities] }
  useEffect(() => {
    const q = query(collection(db, COL), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      const map = {};
      snap.docs.forEach((d) => {
        const data = { ...d.data(), id: d.id };
        if (!map[data.prospectId]) map[data.prospectId] = [];
        map[data.prospectId].push(data);
      });
      setActivitiesMap(map);
    });
    return unsub;
  }, []);

  const addActivity = useCallback(async (prospectId, { type, note, user }) => {
    await addDoc(collection(db, COL), {
      prospectId,
      type,
      note: note || "",
      user: user || "Sales Team",
      date: new Date().toISOString(),
      createdAt: serverTimestamp(),
    });
  }, []);

  const deleteActivity = useCallback(async (prospectId, activityId) => {
    await deleteDoc(doc(db, COL, activityId));
  }, []);

  const getActivities = useCallback(
    (prospectId) => activitiesMap[prospectId] || [],
    [activitiesMap]
  );

  const totalCount = Object.values(activitiesMap).reduce(
    (sum, arr) => sum + arr.length, 0
  );

  return { addActivity, deleteActivity, getActivities, totalCount, activities: activitiesMap };
}
